module.exports = __webpack_public_path__ + "img/logout.f704021b.svg";